import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { accountService } from '../_services';

function Details({ match }) {
    const { path } = match;
    const user = accountService.userValue;
    const { t } = useTranslation();

    let email = user.email;
    if (email.endsWith('@trybook.com.au')) {
        email = "";
    }

    return (
        <div>
            <h3 className='mb-3'>{t("MyProfile")}</h3>
            <p> <strong>{t("CurrentStore")}: </strong>{window.TRYBOOK.storeName}</p>
            {email &&
                <p>
                    <strong>{t("Name")}: </strong> {user.title} {user.displayName} <br />
                    <strong>{t("Email")}: </strong> {email}
                </p>
            }
            <p><Link to={`${path}/update`}>{t("UpdateProfile")}</Link></p>
            {email &&
                <p><Link to={`${path}/update-password`}>{t("UpdatePassword")}</Link></p>
            }
        </div>
    );
}

export { Details };